module.exports = __webpack_public_path__ + "static/media/menu-burger.162e7fce.svg";